import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';
import { useFilterContext } from '~/pages/NewOverview/contexts/FilterContext';
import { handleFilterStateRoute } from '~/pages/NewOverview/helpers/filters';
import { EfficiencyRating } from '~/providers/types/overview';
import { DetailsButton } from '../../../styles';
import { EnergyEfficiencyContainer } from './styles';
import { EnergyEfficiencyTable } from './Table';

interface EnergyEfficiencyInfoProps {
  data: EfficiencyRating | undefined;
  disabled: boolean;
}

export function EnergyEfficiencyInfo({
  data,
  disabled,
}: Readonly<EnergyEfficiencyInfoProps>): ReactElement {
  const [profile] = useState(getUserProfile());
  const { clients, selectedOptions } = useFilterContext();
  const history = useHistory();
  const { t } = useTranslation();

  function onClickDetails(): void {
    history.push('/analise/energia?tipo=energy',
      handleFilterStateRoute(clients, selectedOptions, profile));
  }

  return (
    <>
      <EnergyEfficiencyContainer>
        <EnergyEfficiencyTable
          data={data}
          disabled={disabled}
        />
      </EnergyEfficiencyContainer>
      {!disabled && (
        <DetailsButton
          type="button"
          variant="primary-ghost"
          onClick={onClickDetails}
        >
          {t('verDetalhes')}
        </DetailsButton>
      )}
    </>
  );
}
